export const orderLicenseLink = 'https://skole.aschehoug.no/produktkatalog/modus'
